<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label"
          >{{ $t('addministration.customer_zone_feature.zone_name') }}
          <span class="text-danger">*</span>
        </label>
        <input
          ref="cus_zone_name"
          v-model="model.cus_zone_name"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('cus_zone_name') }"
          :placeholder="
            $t('addministration.customer_zone_feature.enter_zone_name')
          "
        />
        <div class="invalid-feedback" v-if="errors.has('cus_zone_name')">
          {{ errors.first('cus_zone_name') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button @click="cancel()" v-if="editing == true">
          {{ $t('addministration.customer_zone_feature.cancel') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="update"
          v-if="editing == true"
        >
          {{ $t('addministration.customer_zone_feature.update') }}
        </ts-button>
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
          v-else
        >
          {{ $t('addministration.customer_zone_feature.save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'customer-zone-create-form',
  props: ['edit'],
  data() {
    return {
      model: {
        cus_zone_name: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  computed: {},
  mounted() {
    this.$refs.cus_zone_name.focus()
  },
  created() {
    this.setEdit()
  },
  methods: {
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('success_update')
      this.$router.push({ name: 'customer-zone' })
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'customerZone/create',
          this.model
        )
        this.$toasted.success(response.message)
        this.$emit('success_create')
        this.clearForm()
        this.$refs.cus_zone_name.focus()
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    async update() {
      this.saving = true
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'customerZone/update',
          this.model
        )

        this.$toasted.success(response.message)
        this.$router.push({ name: 'customer-zone' })
        this.editing = false
        this.$emit('success_create')
        this.$emit('success_update')
        this.clearForm()
        this.$refs.cus_zone_name.focus()
      } catch (error) {
        this.editing = true
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
      this.saving = false
    },

    setEdit() {
      if (this.edit === null || this.edit === undefined) return

      this.model = Object.assign({}, this.edit)
      this.editing = true
    },

    clearForm() {
      this.model.cus_zone_name = ''
    }
  },
  watch: {
    edit: {
      handler() {
        if (this.edit) {
          this.setEdit()
          this.editing = true
        }
      }
    }
  }
}
</script>
